import { RenderAppropriate } from '../../internals/RenderAppropriate';
import { CardBodyStyle } from '../../styles/display/card.styles';
import React, { ReactNode, ComponentType } from 'react';

interface CardBodyProps {
    children?: ReactNode;
    component?: ComponentType<any>;
    [key: string]: any;
}

const CardBody: React.FC<CardBodyProps> & { Style?: any } = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(CardBodyStyle, rest, children, Component);

CardBody.Style = CardBodyStyle;

export { CardBody };
